import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { editBlog, getBlogCategories, getSingleBlog } from "store/actions";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "components/shared/Loader";
import { getId } from "helpers/functions";
import ImageUploadAr from "./ImageUploadAr";
import JoditEditor from "components/shared/JoditEditor";
const EditBlog = () => {
  const { locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: null,
  });
  // const [selectedImageEn, setSelectedImageEn] = useState({
  //   preview: null,
  //   path: null,
  // });

  const [description, setDescription] = useState({ ar: "", en: "" });
  const [tags, setTags] = useState([]);

  const {
    register,
    handleSubmit,
    reset,

    formState: { errors },
  } = useForm();

  const { singleBlog, loading } = useSelector((state) => state.blogs);

  // const { languages } = useSelector((state) => state.languages);
  const { blogCategories } = useSelector((state) => state.blogCategories) || {};

  useEffect(() => {
    dispatch(getSingleBlog(id));
  }, [dispatch, id]);
  useEffect(() => {
    dispatch(getBlogCategories());
  }, [dispatch]);

  useEffect(() => {
    reset({
      description: singleBlog?.description,
      image: singleBlog?.image,
      tags: singleBlog?.tags,
      title: singleBlog?.title,
      category: getId(singleBlog?.category),
      seo: singleBlog?.seo,
    });

    setSelectedImage({ path: singleBlog?.image });
    // setSelectedImageEn({ path: singleBlog?.imageEn });
    return () => reset({});
  }, [reset, singleBlog]);

  // const renderLanguagesSelectOptions = () => {
  //   return languages.map((language, index) => {
  //     return (
  //       <option value={getId(language)} key={index}>
  //         {language?.name}
  //       </option>
  //     );
  //   });
  // };

  useEffect(() => {
    setTags(singleBlog?.tags);
  }, [singleBlog]);

  useEffect(() => {
    setDescription(singleBlog?.description);
  }, [singleBlog]);

  const renderCategoriesOptions = blogCategories?.map((category) => (
    <option value={getId(category)}>{category?.title?.[locale]}</option>
  ));

  const onSubmit = (data) => {
    if (selectedImage?.path) data.image = selectedImage.path;
    // if (selectedImageEn?.path)
    //   data.imageEn = `uploads/${selectedImageEn.path.split("/").pop()}`;

    // if (selectedBanner && selectedBanner.path)
    // data["banner"] = selectedBanner.path;
    // data.banner = "uploads/" + data.banner.split("/").pop();
    if (selectedImage) data.image = selectedImage?.path;

    data.description = description;
    data.tags = tags;
    delete data.relatedBlogs;
    dispatch(editBlog({ id, data, navigate }));
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="editBlog" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="image" />
                      </h5>
                      <ImageUploadAr
                        selectedImageAr={selectedImage}
                        setSelectedImageAr={setSelectedImage}
                        accept="image/*, video/*"
                      />
                    </div>
                  </Col>
                  {/* <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="imageEn" />
                      </h5>
                      <ImageUploadEn
                        selectedImageEn={selectedImageEn}
                        setSelectedImageEn={setSelectedImageEn}
                        accept="image/*, video/*"
                      />
                    </div>
                  </Col> */}
                  <Col xs={12}>
                    <div className="form-group required">
                      <h5>التصنيف</h5>
                      <div>
                        <select
                          style={{
                            backgroundPosition: "left 0.70rem center",
                          }}
                          className="form-control form-select"
                          {...register("category", {
                            required: true,
                          })}
                        >
                          <optionc value="">اختر التصنيف</optionc>
                          {renderCategoriesOptions}
                        </select>
                      </div>
                      <p className="error-hint">
                        {errors.category?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Row>
                    <Col lg={6} xs={12}>
                      <div className="form-group required">
                        <h5>
                          <FormattedMessage id="title" /> (
                          <FormattedMessage id="arabic" />)
                        </h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("title.ar", {
                              required: true,
                            })}
                          />
                        </div>
                        <p className="error-hint">
                          {errors.title?.ar?.type === "required" && (
                            <FormattedMessage id="required" />
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group required">
                        <h5>
                          <FormattedMessage id="title" /> (
                          <FormattedMessage id="english" />)
                        </h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("title.en", {
                              required: true,
                            })}
                          />
                        </div>
                        <p className="error-hint">
                          {errors.title?.en?.type === "required" && (
                            <FormattedMessage id="required" />
                          )}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  {/* ================= DESCRIPTION ================= */}
                  <Col md={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (AR)
                      </h5>

                      <JoditEditor
                        value={description?.ar}
                        onChange={(val) =>
                          setDescription((prev) => ({
                            ...prev,
                            ar: val,
                          }))
                        }
                        placeholder="اكتب هنا..."
                      />
                    </div>
                  </Col>

                  <Col md={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (EN)
                      </h5>

                      <JoditEditor
                        value={description?.en}
                        onChange={(val) =>
                          setDescription((prev) => ({
                            ...prev,
                            en: val,
                          }))
                        }
                        placeholder="Start typing..."
                      />
                    </div>
                  </Col>

                  {/* <Col lg={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="keywords" />
                      </h5>
                      <div>
                        <Controller
                          control={control}
                          name="tags"
                          render={({
                            field: { onChange, value, selected },
                          }) => (
                            <CreatableSelect
                              isMulti
                              isRtl={true}
                              className="basic-single creatable-select"
                              classNamePrefix="select"
                              options={blogTags.map((tag) => ({
                                value: tag,
                                label: tag,
                              }))}
                              defaultValue={
                                renderTags()?.filter((tag) => {
                                  return tag;
                                }) || []
                              }
                              onChange={(selected) => {
                                const newTags = selected.map(
                                  (tag) => tag.label
                                );

                                setTags(newTags);
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Col> */}
                </Row>

                <div className="seo-data">
                  <h3 className="mb-3">
                    <FormattedMessage id="seoData" />
                  </h3>
                  <Row>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="title" /> (
                          <FormattedMessage id="arabic" />)
                        </h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("seo.title.ar")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="title" /> (
                          <FormattedMessage id="english" />)
                        </h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("seo.title.en")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="description" /> (
                          <FormattedMessage id="arabic" />)
                        </h5>
                        <div>
                          <textarea
                            className="form-control form-outline"
                            {...register("seo.description.ar")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="description" /> (
                          <FormattedMessage id="english" />)
                        </h5>
                        <div>
                          <textarea
                            className="form-control form-outline"
                            {...register("seo.description.en")}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* <Row>
                                    <Col lg={6} xs={12}>
                                        <div className="form-group required">
                                            <h5>
                                                <FormattedMessage id="link" />{" "}
                                            </h5>
                                            <div>
                                                <input
                                                    type="text"
                                                    className="form-control form-outline"
                                                    {...register("seo.link", {
                                                        required: true,
                                                    })}
                                                />
                                            </div>
                                            <p className="error-hint">
                                                {errors.seo?.link?.type ===
                                                    "required" && (
                                                    <FormattedMessage id="required" />
                                                )}
                                            </p>
                                        </div>
                                    </Col>
                                </Row> */}
              </Col>

              <Col lg={4} xs={12}>
                <div className="form-group mt-3">
                  <button type="submit" className="btn btn-blue">
                    <FormattedMessage id="saveChanges" />
                  </button>
                </div>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditBlog;
